var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("p", { staticClass: "datasources-link" }, [
        _c(
          "a",
          {
            on: {
              click: function ($event) {
                $event.preventDefault()
                _vm.showModal = true
              },
            },
          },
          [_vm._v("Data sources")]
        ),
      ]),
      _vm._v(" "),
      _vm.showModal
        ? _c(
            "modal",
            {
              attrs: { size: "medium", "vertical-position": "top" },
              on: {
                close: function ($event) {
                  _vm.showModal = false
                },
              },
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("h3", [_vm._v("Data sources")]),
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c("div", {
                  staticClass: "datasources-content",
                  domProps: { innerHTML: _vm._s(_vm.content) },
                }),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }